import { render, staticRenderFns } from "./List-Shipping-Addresses.vue?vue&type=template&id=36a68083&scoped=true"
import script from "./List-Shipping-Addresses.vue?vue&type=script&lang=js"
export * from "./List-Shipping-Addresses.vue?vue&type=script&lang=js"
import style0 from "./List-Shipping-Addresses.vue?vue&type=style&index=0&id=36a68083&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a68083",
  null
  
)

export default component.exports